// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__fc0 {
  padding: calc(var(--ring-unit) * 2.5);
  width: calc(var(--ring-unit) * 90);
  border: 1px solid var(--ring-line-color);
  border-radius: var(--ring-border-radius);

  display: flex;
  flex-direction: column;
  gap: calc(var(--ring-unit) * 1.25);

  .infoSection__be5 {
    margin-left: calc(var(--ring-unit) * 4.5);
    display: flex;
    flex-direction: column;
    gap: calc(var(--ring-unit) * 1.5);

    .disabledSection__b39 {
      display: flex;
      flex-direction: column;
    }
  }

  .header__c50 {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .headerSection__c61 {
      display: flex;
      align-items: center;
      justify-content: centert;
      gap: calc(var(--ring-unit) * 1.5);
    }

    .previewText__fb7 {
      align-self: center;
      background: linear-gradient(90deg, rgba(72, 224, 84, 1), rgba(107, 87, 255, 1));
      color: transparent;
      background-clip: text;
    }
  }

  .footer__d87 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: calc(var(--ring-unit) * 1.5);
  }
}

.clearSpaces__ba5.clearSpaces__ba5 {
  padding: 0;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/profiles/profile-details/profile-ai/ai-available/ai-tools/enable-junie-banner.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,wCAAwC;EACxC,wCAAwC;;EAExC,aAAa;EACb,sBAAsB;EACtB,kCAAkC;;EAElC;IACE,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,iCAAiC;;IAEjC;MACE,aAAa;MACb,sBAAsB;IACxB;EACF;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;IAEnB;MACE,aAAa;MACb,mBAAmB;MACnB,wBAAwB;MACxB,iCAAiC;IACnC;;IAEA;MACE,kBAAkB;MAClB,+EAA+E;MAC/E,kBAAkB;MAClB,qBAAqB;IACvB;EACF;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,iCAAiC;EACnC;AACF;;AAEA;EACE,UAAU;EACV,SAAS;AACX","sourcesContent":[".container {\n  padding: calc(var(--ring-unit) * 2.5);\n  width: calc(var(--ring-unit) * 90);\n  border: 1px solid var(--ring-line-color);\n  border-radius: var(--ring-border-radius);\n\n  display: flex;\n  flex-direction: column;\n  gap: calc(var(--ring-unit) * 1.25);\n\n  .infoSection {\n    margin-left: calc(var(--ring-unit) * 4.5);\n    display: flex;\n    flex-direction: column;\n    gap: calc(var(--ring-unit) * 1.5);\n\n    .disabledSection {\n      display: flex;\n      flex-direction: column;\n    }\n  }\n\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .headerSection {\n      display: flex;\n      align-items: center;\n      justify-content: centert;\n      gap: calc(var(--ring-unit) * 1.5);\n    }\n\n    .previewText {\n      align-self: center;\n      background: linear-gradient(90deg, rgba(72, 224, 84, 1), rgba(107, 87, 255, 1));\n      color: transparent;\n      background-clip: text;\n    }\n  }\n\n  .footer {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: calc(var(--ring-unit) * 1.5);\n  }\n}\n\n.clearSpaces.clearSpaces {\n  padding: 0;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container__fc0`,
	"infoSection": `infoSection__be5`,
	"disabledSection": `disabledSection__b39`,
	"header": `header__c50`,
	"headerSection": `headerSection__c61`,
	"previewText": `previewText__fb7`,
	"footer": `footer__d87`,
	"clearSpaces": `clearSpaces__ba5`
};
export default ___CSS_LOADER_EXPORT___;
